import { render, staticRenderFns } from "./AlertList.vue?vue&type=template&id=6b0f6562"
import script from "./AlertList.vue?vue&type=script&lang=js"
export * from "./AlertList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.33_css-loader@6.11.0_webpack@5.106.2__lodash@4_f4dcab5a642c45ba976dfd98f0465f82/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports